import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofz22V4Wt } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4_WT: Record<
  Exclude<PageIdWoofz22V4Wt, PageIdWoofz22V4Wt.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofz22V4Wt.SEX_22V4_WT]: {
    id: PageIdWoofz22V4Wt.SEX_22V4_WT,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.DOG_AGE_22V4_WT]: {
    id: PageIdWoofz22V4Wt.DOG_AGE_22V4_WT,
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.DOG_BREED_22V4_WT]: {
    id: PageIdWoofz22V4Wt.DOG_BREED_22V4_WT,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.DOG_BREED_ID_22V4_WT]: {
    id: PageIdWoofz22V4Wt.DOG_BREED_ID_22V4_WT,
  },
  [PageIdWoofz22V4Wt.URGE_22V4_WT]: {
    id: PageIdWoofz22V4Wt.URGE_22V4_WT,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.COMMANDS_61_22V4_WT]: {
    id: PageIdWoofz22V4Wt.COMMANDS_61_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.COMMANDS_62_22V4_WT]: {
    id: PageIdWoofz22V4Wt.COMMANDS_62_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.COMMANDS_63_22V4_WT]: {
    id: PageIdWoofz22V4Wt.COMMANDS_63_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.URGE_2_22V4_WT]: {
    id: PageIdWoofz22V4Wt.URGE_2_22V4_WT,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.POTTY_22V4_WT]: {
    id: PageIdWoofz22V4Wt.POTTY_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.BEHAVIOR_22V4_WT]: {
    id: PageIdWoofz22V4Wt.BEHAVIOR_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.TRAINING_22V4_WT]: {
    id: PageIdWoofz22V4Wt.TRAINING_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Wt.PREPARE_FLOW_22V4_WT]: {
    id: PageIdWoofz22V4Wt.PREPARE_FLOW_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.DOG_STATISTICS_22V4_WT]: {
    id: PageIdWoofz22V4Wt.DOG_STATISTICS_22V4_WT,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofz22V4Wt.EMAIL_22V4_WT]: {
    id: PageIdWoofz22V4Wt.EMAIL_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.NEWSLETTER_URGE_22V4_WT]: {
    id: PageIdWoofz22V4Wt.NEWSLETTER_URGE_22V4_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Wt.LAST_CHANCE_OFFER_22V4_WT]: {
    id: PageIdWoofz22V4Wt.LAST_CHANCE_OFFER_22V4_WT,
  },
  [PageIdWoofz22V4Wt.WELCOME_TO_WOOFZ_22V4_WT]: {
    id: PageIdWoofz22V4Wt.WELCOME_TO_WOOFZ_22V4_WT,
    hasHeader: true,
  },
  [PageIdWoofz22V4Wt.SUBSCRIPTIONS_22V4_WT]: {
    id: PageIdWoofz22V4Wt.SUBSCRIPTIONS_22V4_WT,
  },
  [PageIdWoofz22V4Wt.CANCEL_OFFER_22V4_WT]: {
    id: PageIdWoofz22V4Wt.CANCEL_OFFER_22V4_WT,
  },
  [PageIdWoofz22V4Wt.CHAT_UPSELL_22V4_WT]: {
    id: PageIdWoofz22V4Wt.CHAT_UPSELL_22V4_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Wt.UPSELL_22V4_WT]: {
    id: PageIdWoofz22V4Wt.UPSELL_22V4_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Wt.UPSELL_FEEDING_GUIDE_22V4_WT]: {
    id: PageIdWoofz22V4Wt.UPSELL_FEEDING_GUIDE_22V4_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Wt.UPSELL_EMOTIONAL_SUPPORT_22V4_WT]: {
    id: PageIdWoofz22V4Wt.UPSELL_EMOTIONAL_SUPPORT_22V4_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Wt.DOWNLOAD_22V4_WT]: {
    id: PageIdWoofz22V4Wt.DOWNLOAD_22V4_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
